import gql from 'graphql-tag';

const CREATE_RESOLUTION = gql`
  mutation CreateMonitoringResolution($data: CreateMonitoringResolutionInput!) {
    createMonitoringResolution(data: $data) {
      id
      text
      custom {
        id
        text
      }
    }
  }
`;

const DELETE_RESOLUTION_BY_ID = gql`
  mutation DeleteMonitoringResolutionById($id: ID!) {
    deleteMonitoringResolutionById(id: $id) {
      id
    }
  }
`;

const UPDATE_RESOLUTION_BY_ID = gql`
  mutation UpdateMonitoringResolutionById(
    $data: UpdateMonitoringResolutionInput
    $id: ID!
  ) {
    updateMonitoringResolutionById(data: $data, id: $id) {
      id
      text
      custom {
        id
        text
      }
    }
  }
`;

export default {
  CREATE_RESOLUTION,
  DELETE_RESOLUTION_BY_ID,
  UPDATE_RESOLUTION_BY_ID,
};
